export default __webpack_public_path__ + "static/suv-soueast-a682fa8cc9913a68a5f13200ce2aaca7.png";